<template>
    <Paper class="process-barcode">
        <i class="page-description-question el-icon-question" :data-title="pageDescription"></i>
        <el-tabs v-model="activeName">
            <el-tab-pane name="BarTrack">
                <span slot="label">条码全流程跟踪</span>
                <BarTrack :pageDescription="pageDescription" :billNosMain="billNosMain"></BarTrack>
            </el-tab-pane>
            <el-tab-pane name="HistoryBarTrack">
                <span slot="label">历史条码流向跟踪</span>
                <HistoryBarTrack></HistoryBarTrack>
            </el-tab-pane>
        </el-tabs>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import BarTrack from './Components/BarTrack/Index';
import HistoryBarTrack from './Components/HistoryBarTrack/Index';
import { dictWithUrl } from '../../../components/basicDataDialog/api';
export default {
    name: 'processSearch',
    components: { Paper, BarTrack, HistoryBarTrack },
    data() {
        return {
            activeName: 'BarTrack',
            pageDescription: '',
            billNosMain: ''
        };
    },
    methods: {
        async dictData() {
            const option = await dictWithUrl('BILL_DESC');// BILL_DESC-菜单描述
            const dictOptions = {};
            if (+option.code === 0) {
                const dictList = option.data.BILL_DESC;
                dictList.forEach(item => {
                    dictOptions[item.code] = item.name;
                });
            }
            this.pageDescription = dictOptions[(this.$options.name) + 'Menu'].replace(/ {2}/g, '\n');
            this.billNosMain = dictOptions[this.$options.name].replace(/ {2}/g, '\n');
        }
    },
    async created() {
        await this.dictData();
    }
};
</script>
<style lang="less" src='./Index.less'></style>